/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { Action, ActionCreators } from './actions';
import { RootState } from '../index';
import { handleErrorInterceptor } from '../../utils/AuthUtils';

const requestHubsSuccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedHubsSuccess.create(response);
};

const requestHubsError = (error: AjaxError): any => {
  return ActionCreators.ReceivedHubsError.create(error);
};

export const requestHubsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestHubs.type),
    switchMap(
      ($action: any): Observable<Action> =>
        ajaxRaw.get('/hubs').pipe(
          map((response: AjaxResponse<any>): Action => requestHubsSuccess(response)),
          catchError(
            (error: AjaxError): Observable<Action> =>
              handleErrorInterceptor(
                error,
                of(requestHubsError(error))
              ),
          ),
        ),
    ),
  );
